var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgModeMetro = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 3.01C0 1.393 1.347.045 2.964.045H20.93c1.677 0 3.025 1.348 3.025 2.965v17.966A3.016 3.016 0 0 1 20.93 24H2.964C1.347 24 0 22.653 0 20.976z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17.261 9.106v-.504c0-.03.06-.059.12-.059V20.64h3.739V2.88h-5.517l-3.467 12.127-.06.83h-.091l-.09-.83L8.426 2.88H2.88v17.76h3.799V8.543c.03 0 .09.03.09.06v.503l3.377 11.534h3.708z"
}))));
export { SvgModeMetro as ReactComponent };